import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import GitlabOutlinedSvg from "@ant-design/icons-svg/es/asn/GitlabOutlined";
import AntdIcon from "../components/AntdIcon";
var GitlabOutlined = function GitlabOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: GitlabOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  GitlabOutlined.displayName = 'GitlabOutlined';
}
export default /*#__PURE__*/React.forwardRef(GitlabOutlined);